import CpfToast from "../../utils/checkout/CpfToast";
import Toast from "../../utils/Toast";

export default class SessionDate {

    constructor() {
        this.initMethods();
        this.bindEvents();
        this.toast = new CpfToast();
        this.dataLayer = {};
        this.page = 2;

        window.application.setOnDataChangeListener(this);
    }

    initMethods() {
        const self = this;
        this.onSessionClick = (e) => { self.sendSession(); }
        this.onRequestClick = (e) => {
            self.setGtmDataLayer()
            self.createRequest(e)
        };
        this.onLoadMoreClick = (e) => { self.loadMore(); }
        this.onFallbackSessionClick = (e) => { self.pushFallbackEvent(e); }
        this.onAlternativeSessionClick = (e) => { self.pushAlternativeEvent(e); }

    }

    bindEvents() {
        this.bindSessionRadioClicks();
        $('#request-button').click(this.onRequestClick);
        $('#load-more').click(this.onLoadMoreClick);
        $(document).on('click', '.checkout-empty-section[data-fallback-type] input[name="record[session_id]"]', this.onFallbackSessionClick);
        $(document).on('click', '.alternative-card', this.onAlternativeSessionClick);

        // Delegate partner-tag click to avoid card's click handler
        $(document).off('click.partnerTag').on('click.partnerTag', '.partner-tag', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('#partner-modal').modal('show');
        });

        // Delegate discount-tag click to open discount modal
        $(document).off('click.discountTag').on('click.discountTag', '.discount-tag', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('#discount-modal').modal('show');
        });

        // Populate discount modal with dynamic value (opened via discount tag)
        const self = this;
        $('#discount-modal').on('show.bs.modal', function(event) {
            const button = $(event.relatedTarget);
            if(!button || button.length === 0) { return; }
            const discountRaw = button.data('discount');
            const phone = button.data('phone');
            self.populateDiscountModal(discountRaw, phone);
        });
    }

    onDataChanged(data) {
        if(data.dataLayer){ this.dataLayer = data.dataLayer; }
    }

    onDestroy() {
    }

    createRequest(e) {
        let el = $(e.currentTarget);
        let url = el.data('url');

        $.ajax({
            url: url,
            type: 'POST',
            success: this.showSuccess,
        });
    }

    showSuccess() {
        $("#card-create-notification").addClass('d-none');
        $("#card-create-notification-success").removeClass('d-none');
    }

    setGtmDataLayer(eventOverride = null) {
        const payload = $.extend(true, {}, this.dataLayer);
        if(eventOverride){ payload.event = eventOverride; }
        window.dataLayer.push(payload);
    }

    loadMore() {
        let self = this;
        $.ajax({
            url: window.location.href,
            type: 'GET',
            data: { page: this.page },
            success: (data) => {
                self.appendSessions(data)
            },
        });
    }

    sendSession() {
        this.setGtmDataLayer('select_date');
        $('#session_date_form').submit()
    }

    appendSessions(data) {
        $('#session-list').append(data);
        this.page++;
        // get last .page and check data-has-more is true
        let lastPage = $('.page').last();
        if (lastPage.data('has-more') === false) {
            $('#load-more').addClass('d-none');
        }
        // Rebind radio clicks (including newly appended) to custom handler
        this.bindSessionRadioClicks();
    }

    bindSessionRadioClicks(){
        const self = this;
        $('[name="record[session_id]"]').off('click.sessiondate').on('click.sessiondate', function(e){ self.handleSessionSelect(e); });
    }

    populateDiscountModal(discountRaw, phone){
        const discount = parseFloat(discountRaw);
        if(isNaN(discount)) { return; }
        const formatted = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(discount);
        const modal = $('#discount-modal');
        modal.find('#discount-value').text('Remise de ' + formatted);
        const checkbox = modal.find('#discount-delay-checkbox');
        if(checkbox.length){ checkbox.prop('checked', false); }
        $('#discount-checkbox-error').addClass('d-none');
        if(phone){ 
            const phoneLink = modal.find('#discount-phone');
            phoneLink.text(phone);
            phoneLink.attr('href', 'tel:' + phone);
        }
    }

    handleSessionSelect(e){
        const radio = $(e.currentTarget);
        const hasPartner = radio.data('partner-tag');
        const hasDiscount = radio.data('discount-tag');

        if(!hasPartner && !hasDiscount){
            // Normal flow
            this.onSessionClick(e);
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        // Clear existing selection then select this one explicitly
        $('[name="record[session_id]"]').prop('checked', false);
        radio.prop('checked', true);

        this.selectedTaggedSessionId = radio.val();

        if(hasDiscount){
            this.populateDiscountModal(radio.data('discount-amount'), radio.data('phone'));
            $('#discount-modal').modal('show');
        } else if(hasPartner){
            $('#partner-modal').modal('show');
        }

        const self = this;
        $('#discount-modal-validate').off('click.validate').on('click.validate', function(){
            if (!$('#discount-delay-checkbox').is(':checked')) {
                $('#discount-checkbox-error').removeClass('d-none');
                return;
            }
            self.validateTaggedSession('#discount-modal');
        });
        $('#partner-modal-validate').off('click.validate').on('click.validate', function(){ self.validateTaggedSession('#partner-modal'); });
    }

    validateTaggedSession(modalSelector){
        if(this.selectedTaggedSessionId){
            const radio = $(`[name="record[session_id]"][value='${this.selectedTaggedSessionId}']`);
            if(radio.length){
                $('[name="record[session_id]"]').prop('checked', false);
                radio.prop('checked', true);
            }
        }
        this.sendSession();
    }

    pushFallbackEvent(e) {
        const type = $(e.currentTarget).closest('.checkout-empty-section').data('fallback-type');
        const event = type === 'maxi' ? 'other_formula_maxi' : 'other_formula_mini';
        window.dataLayer.push({ event });
    }

    pushAlternativeEvent(e) {
        const form = $(e.currentTarget).closest('form');
        window.dataLayer.push({ event: 'other_cities' });
        form.submit();
    }

}